import React, { useState, useEffect, useRef } from 'react'
import {
    Layout, Flex, Button, Input, Avatar, Card, Divider, Tag, Badge, Radio, Drawer, Skeleton,
    List, InputNumber, Alert,
    Result
} from 'antd'
import {
    CheckCircleFilled, CheckOutlined,
    CommentOutlined, CreditCardOutlined, EllipsisOutlined, PlusOutlined, GiftOutlined,
    MinusOutlined, LeftCircleOutlined, LeftOutlined, NotificationOutlined, PercentageOutlined,
    RightCircleOutlined, RightOutlined, ShoppingOutlined,
    WhatsAppOutlined,
} from '@ant-design/icons'
import './delivery.css'
import LOGO from '../../img/lion-head.png'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import PLACEHOLDER from '../../img/placeholder.png'
import { getLoja, getLocalizarCupom, getFidelidade, getCampanhasResgateItens, postPedido, getOpen } from '../../services/bd/cardapioDigital'
import { useToasts } from 'react-toast-notifications'
import { useParams, useNavigate, Outlet, useLocation } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import { deliveryUserState, deliveryUserEnderecosState, deliveryUltimosPedidosState, deliveryUserNoRegisterState } from '../../store/recoilData'
import { useRecoilValue } from 'recoil'
import { Tabs as TabsR, Image, Placeholder } from 'rsuite'
import { useRecoilState } from 'recoil'
import { deliveryPedidosState } from '../../store/recoilData'
import SHOP_BAG from '../../img/shopping-bag.png'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { EnderecosCtrl } from './enderecosCtrl'
import PIX from '../../img/pix.png'
import POS from '../../img/terminal-pos.png'
import TAKEAWAY from '../../img/takeaway.png'
import ENTREGA from '../../img/delivery-man.png'
import PIX_LOGO from '../../img/pix_logo.png'
import SELO from '../../img/selo.png'
import TRISTE from '../../img/cart-empty.png'
import { BASEURLRAIZ } from '../../services/api.service'
import TRISTE2 from '../../img/triste.png'
import PaymentCtrl from './paymentCtrl'
import PaymentStatusCtrl from './paymentStatusCtrl'
import dayjs from 'dayjs'
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import SMARTPHONE from '../../img/smartphone.png'
import NOMEPNG from '../../img/avatar-masculino.png'
import { diferencaDias, segundosToHorario, validaCelular, horarioToSegundos } from '../../services/util'
import CupomCtrl from './cupomCtrl'
import { isMobile } from 'react-device-detect'
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import PaymentPagamerCtrl from './paymentPagarmeCtrl'

export const OutletDelivery = (props) => {

    const location = useLocation()
    const user = useRecoilValue(deliveryUserState)
    const [userNoRegister, setUserNoRegister] = useRecoilState(deliveryUserNoRegisterState)
    const navigate = useNavigate()
    const [tabSelected, setTabSelected] = useState(0)
    const { nome } = useParams()
    const { addToast } = useToasts()
    const [loadingLoja, setLoadingLoja] = useState(false)

    const [openCadastro, setOpenCadastro] = useState(false)
    const [currentStep, setCurrentStep] = useState(0)

    const [openPaymentEntrega, setOpenPaymentEntrega] = useState(false)
    const [openCart, setOpenCart] = useState(false)
    const [pedidoDelivery, setPedidoDelivery] = useRecoilState(deliveryPedidosState)
    const [openTroco, setOpenTroco] = useState(false)
    const [troco, setTroco] = useState(0)

    const [openEdit, setOpenEdit] = useState(false)
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [itemSelected, setItemSelected] = useState(undefined)
    const [openSelected, setOpenSelected] = useState(false)
    const [selectedValided, setSelectedValidad] = useState(false)

    const [enderecos, setEnderecos] = useRecoilState(deliveryUserEnderecosState)
    const [taxa, setTaxa] = useState(-1)
    const [deliveryType, setDeliveryType] = useState('1')

    const [openCupom, setOpenCupom] = useState(false)
    const [cupom, setCupom] = useState({ codigo: '' })
    const [msgCupom, setMsgCupom] = useState('')

    const [openFidelidade, setOpenFidelidade] = useState(false)
    const [fidelidade, setFidelidade] = useState({})
    const [resgate, setResgate] = useState({ valor: 0 })

    const [openCampanha, setOpenCampanha] = useState(false)
    const [campanha, setCampanha] = useState(undefined)
    const [campanhaItens, setCampanhaitens] = useState([])
    const [sending, setSending] = useState(false)

    const [openPaymentOnline, setOpenPaymentOnline] = useState(false)

    const [respPedido, setRespPedido] = useState(undefined)
    const [openPedido, setOpenPedido] = useState(false)

    const [pedidosUltimos, setPedidosUltimos] = useRecoilState(deliveryUltimosPedidosState)
    const [openEnviado, setOpenEnviado] = useState(false)


    const contadorSegundos = useRef(0)
    const [tempo, setTempo] = useState('')

    //daddos para cartão de credito
    const [state, setState] = useState({
        number: '',
        expiry: '',
        cvc: '',
        name: '',
        focus: '',
    });

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;

        setState((prev) => ({ ...prev, [name]: value }));
    }

    const handleInputFocus = (evt) => {
        setState((prev) => ({ ...prev, focus: evt.target.name }));
    }



    const appref = useRef({
        cor: 'transparent',
        nome: '',
        icon: LOGO
    })

    const [force, setForce] = useState(0)



    useEffect(() => {
        if (nome) {
            loadLoja()
         //   console.log(pedidoDelivery[nome])
        }
        console.log(respPedido)
        const intervalId = setInterval(() => {
            //  console.log('interval', respPedido)
            if (respPedido) {
                if (respPedido.pedido) {
                    if (respPedido.pedido.createAt) {
                        //  console.log(diferencaDias(respPedido.pedido.createAt))

                        const dataInicial = new Date(respPedido.pedido.createAt);
                        const dataFinal = new Date();

                        // Diferença em milissegundos
                        const diffEmMilissegundos = dataFinal - dataInicial;

                        // Conversões
                        const totalSegundos = Math.abs(Math.floor(diffEmMilissegundos / 1000));
                        if (totalSegundos < 0)
                            contadorSegundos.current = totalSegundos
                        else
                            contadorSegundos.current = 0
                        const minutos = Math.floor(totalSegundos / 60);
                        const segundosRestantes = totalSegundos % 60;
                        setTempo(value => `Diferença: ${minutos}:${segundosRestantes}`)

                        //  
                        // 

                     //   console.log(`Diferença: ${minutos}:${segundosRestantes}`, tempo);
                        //  contadorSegundos.current = totalSegundos


                    }
                }
            }
        }, 1000); //1 second

        // Cleanup function to clear the interval when the component unmounts
        return () => {
            clearInterval(intervalId);
        };

    }, [])


    useEffect(() => {
        sumItens()
        calcularTaxa()
        calcularCupom()
    }, [location, pedidoDelivery])

    useEffect(() => {
        calcularTaxa()
    }, [enderecos, currentStep, deliveryType])

    useEffect(() => {
        if (itemSelected) {
            validarGrupos()
        }
    }, [itemSelected])



    useEffect(() => {
        const intervalId = setInterval(() => {
            checkOpen()
        }, 30000); //30 second

        // Cleanup function to clear the interval when the component unmounts
        return () => {
            clearInterval(intervalId);
        };
    }, [])


    async function checkOpen() {
        try {

            const resp = await getOpen({ nome: nome })

            let aux = JSON.parse(JSON.stringify(appref.current))
            aux.status = resp

            // appref.current = resp
            // setApp({ ...app, status: resp })
            //  console.log(resp)
            if (JSON.stringify(appref.current.status) !== JSON.stringify(resp)) {
                appref.current = aux
                setForce(prev => prev + 1)
            }

        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoadingLoja(false)
    }



    function calcularTotal() {
        return (parseFloat(sumItens()) - (parseFloat(calcularCupom())) - resgate.valor + (taxa > 0 ? taxa : 0))
    }

    function calcularCupom() {
        try {
            if (cupom?.idcupons > 0) {
                if (cupom.tipo === 0) {
                    return cupom.valor.toFixed(2)
                } else if (cupom.tipo === 1) {
                    return (parseFloat(sumItens()) * parseFloat(cupom.valor) / 100).toFixed(2)
                } else {
                    return 0
                }
            } else return 0

        } catch (error) {
            return 0
        }
    }

    function renderValores() {
        return <>
            <Flex style={{ color: '#1e1d1dff', fontWeight: 600, marginTop: 10 }}>Resumo dos Valores</Flex>
            <Card size='small'>
                <Flex vertical >
                    <Flex align='center' justify='space-between'>
                        <Flex gap={10} align='center'>
                            <Flex>Subtotal</Flex>
                        </Flex>
                        <Flex>R$ {sumItens()}</Flex>
                    </Flex>
                    {parseInt(deliveryType) === 1 && taxa >= 0 && <>
                        <Divider style={{ marginTop: 5, marginBottom: 5 }} />

                        <Flex align='center' justify='space-between'>
                            <Flex gap={10} align='center'>
                                <Flex>(+) Taxa de Entrega</Flex>
                            </Flex>
                            <Flex>R$ {taxa.toFixed(2)}</Flex>
                        </Flex>
                    </>
                    }

                    {cupom?.idcupons > 0 && <>
                        <Divider style={{ marginTop: 5, marginBottom: 5 }} />

                        <Flex align='center' justify='space-between'>
                            <Flex gap={10} align='center'>
                                <Flex>(-) Cupom</Flex>
                            </Flex>
                            <Flex>-R$ {calcularCupom()}</Flex>
                        </Flex>
                    </>
                    }

                    {resgate?.valor > 0 && <>
                        <Divider style={{ marginTop: 5, marginBottom: 5 }} />

                        <Flex align='center' justify='space-between'>
                            <Flex gap={10} align='center'>
                                <Flex>(-) Fidelidade</Flex>
                            </Flex>
                            <Flex>-R$ {resgate.valor.toFixed(2)}</Flex>
                        </Flex>
                    </>
                    }

                    <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                    <Flex align='center' justify='space-between' style={{ fontSize: '1.2em', color: '#292929ff', fontWeight: 600 }}>
                        <Flex gap={10} align='center'>
                            <Flex style={{ fontWeight: 600 }}>Total</Flex>
                        </Flex>
                        <Flex>R$ {calcularTotal().toFixed(2)}</Flex>
                    </Flex>
                </Flex>
            </Card>
        </>
    }


    function calcularTaxa() {
        try {
            let _taxa = -1;
            if (parseInt(deliveryType) === 1) {
                let enderecoPrinciapl = enderecos.filter(v => v.isprincipal === 1)
                if (enderecoPrinciapl && enderecoPrinciapl.length > 0) {
                    appref.current?.delivery?.map((item) => {
                        if (item.name.toUpperCase() === enderecoPrinciapl[0].district.toUpperCase()) {
                            _taxa = item.value
                        }
                    })
                } else {

                }
            } else {
                _taxa = 0
            }
            setTaxa(_taxa)
        } catch (error) {
            console.log(error.message)
        }
    }

    function validarGrupos() {
        let valided = true
        itemSelected?.groups?.map((grupo, indexgp) => {
            if (grupo.mandatory > 0) {
                if (!grupo.valided)
                    valided = false
            } else {
                grupo.valided = true
            }
        })
        setSelectedValidad(valided)
    }

    async function loadLoja() {
        try {

            setLoadingLoja(true)
            const resp = await getLoja({ nome: nome })
            //   setApp(resp)
            console.log(resp)
            appref.current = resp

        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoadingLoja(false)
    }







    function sumItens() {
        var total = 0

        try {
            if (pedidoDelivery) {
                if (pedidoDelivery[nome]) {
                    if (pedidoDelivery[nome].itens) {
                        pedidoDelivery[nome].itens.map(itemSelected => {
                            let vunit = itemSelected?.promotype === 0 ? parseFloat(itemSelected.promovalue) :
                                parseFloat(itemSelected?.value)
                            total = total + parseFloat(itemSelected?.quant) * vunit
                            itemSelected?.groups?.map((gp, indexgp) => {
                                gp.items?.map(item => {
                                    if (item.sel > 0) {
                                        total = total + parseFloat(itemSelected.quant) * (parseFloat(item.sel) * parseFloat(item.value))
                                    }
                                })
                            })
                        })
                    }
                }
            }


        } catch (error) {

        }
        return total.toFixed(2)
    }

    function addItem(it) {
        try {
            let item = JSON.parse(JSON.stringify(it))
            if (item.promotype === 0)
                item.value = item.promovalue

            item?.groups?.map((gp, indexgp) => {
                gp.items = gp.items.filter(value => value.sel > 0)
            })
            item?.groups?.map((gp, indexgp) => {
                gp.items.map((value) => {
                    if (value.promotype === 0)
                        value.value = parseFloat(value.promovalue)
                })
            })

            let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
            pedidos[nome].itens[selectedIndex] = item

            setPedidoDelivery(pedidos)

        } catch (error) {
            console.log(error.message)
        }
    }

    function sumItem() {
        var total = 0

        try {
            let vunit = itemSelected?.promotype === 0 ? parseFloat(itemSelected.promovalue) : parseFloat(itemSelected?.value)
            total = parseFloat(itemSelected?.quant) * vunit
            itemSelected?.groups?.map((gp, indexgp) => {
                gp.items?.map(item => {
                    if (item.sel > 0) {
                        total = total + parseFloat(itemSelected.quant) * (parseFloat(item.sel) * parseFloat(item.value))
                    }
                })
            })

        } catch (error) {

        }
        return total.toFixed(2)
    }

    function renderPreco(item) {

        if (item?.ispattern === 0) {
            return <Flex align='center' gap={2} >
                <Flex style={{ color: '#50a773' }}>a partir R${item?.apartir}</Flex>
            </Flex>

        } else if (item?.promotype === 0) {
            return <Flex gap={5} flex={1} style={{ lineHeight: 1 }} align='center'>
                <Flex justify='flex-start' style={{ color: '#50a773', fontWeight: 'inherit', fontSize: '1.1em' }}>R${item?.promovalue.toFixed(2)}</Flex>
                <Flex align='center' style={{ color: '#c0c0c0', fontSize: '.9em', textDecoration: 'line-through', lineHeight: 1 }} gap={4}>
                    R${parseFloat(item?.value).toFixed(2)}
                    {<Tag style={{ fontSize: '0.8em' }} color={appref.currentcor}>
                        <b>-</b>{item.value > 0 ? (100 - (item.promovalue * 100 / item.value)).toFixed(0) : 100}{'%'}
                    </Tag>}

                </Flex>
            </Flex>
        } else {
            return <Flex flex={1}
                style={{ fontSize: '1.1em', fontWeight: 'inherit' }}>
                R${parseFloat(item?.value).toFixed(2)}
            </Flex>
        }
    }

    function renderPedido(allowEdit) {
        return <Flex style={{ padding: 10, marginTop: 10, backgroundColor: 'whitesmoke' }} vertical gap={5} flex={1}>

            <Flex style={{ color: '#1e1d1dff', fontWeight: 600 }}>Minhas Informações</Flex>
            <Card size='small' style={{ flex: 1, display: 'flex' }} id='cardMyInfo'>
                <Flex vertical style={{ width: '100%' }}>
                    <span>
                        <img height={18} width={18} style={{ objectFit: 'contain' }} src={NOMEPNG} alt='nomepng'/> Nome</span>
                    {user?.customer_id > 0 ? <div style={{ marginBottom: 10 }}><b>{user?.name}</b></div> : <Input

                        disabled={user?.name}
                        placeholder='Seu nome'
                        style={{ width: '100%', flex: 1, marginBottom: 10 }}
                        value={user?.name ? user.name : userNoRegister.name}
                        onChange={(e) => {
                            setUserNoRegister({ ...userNoRegister, name: e.target.value })
                        }} />}

                    <span ><img height={15} width={15} style={{ objectFit: 'contain' }} src={SMARTPHONE} alt='smart'/> Celular</span>
                    {user?.customer_id > 0 ? <div><b>{user?.phone}</b></div> :
                        <TelefoneBrasileiroInput
                            inputMode='numeric'
                            disabled={user?.phone}
                            placeholder="00 9 9999-99999"
                            autocomplete="off"
                            autoComplete="off"
                            className={"ant-input css-dev-only-do-not-override-aya5jp ant-input-outlined"}
                            style={{
                                paddingLeft: 6, paddingTop: 5, paddingBottom: 5, autocomplete: "off", borderRadius: 5, borderWidth: 0.3,
                                BorderColor: 'ligthgray'
                            }}
                            value={user?.phone ? user?.phone : userNoRegister?.phone}
                            onChange={(e) => {
                                setUserNoRegister({ ...userNoRegister, phone: e.target.value })
                            }}
                            temDDD
                            separaNono={true}
                            separaDDD={true} />
                    }


                    {
                        !(user?.customer_id > 0) && userNoRegister.name === '' && !validaCelular(userNoRegister.phone) &&
                        <Alert banner message={"Nome e Telefone obrigatório!"} showIcon type='error' style={{ marginTop: 10, flex: 1, width: '100%' }} />
                    }

                </Flex>
            </Card>

            <Flex style={{ color: '#1e1d1dff', fontWeight: 600 }}>Itens adicionados</Flex>
            <Card size='small' style={{ flex: 1, display: 'flex', width: '100%' }}>
                <Flex vertical gap={0}>
                    {pedidoDelivery[nome].itens.map((item, index) => {
                        let total = 0
                        total = total + item.quant * item.value
                        return <Flex vertical>
                            <div style={{ color: '#000' }}>
                                {item.quant} X {item.nome ? item.nome : item.name}  {item.value > 0 && "R$ ".concat((item.value.toFixed(2)))}
                            </div>
                            {item.groups.map((grupo, indexGrupo) => {
                                return <div style={{ color: '#5c5c5cff' }}>
                                    {grupo.items.map((grupoItem, indexGrupoIndex) => {
                                        total = total + item.quant * parseFloat(grupoItem.value) * parseFloat(grupoItem.sel)
                                        return <div>
                                            {grupoItem.sel} x {grupoItem.name} {grupoItem.value > 0 && "R$ ".concat(parseFloat(grupoItem.value).toFixed(2))}
                                        </div>
                                    })}
                                </div>
                            })}
                            <span style={{ color: '#000' }}>R$ {total.toFixed(2)}</span>
                            {allowEdit && <EllipsisOutlined style={{ fontSize: '1.3em', color: appref.current?.cor }} onClick={() => {
                                setSelectedIndex(index)
                                setItemSelected(JSON.parse(JSON.stringify({ ...item })))
                                setOpenEdit(true)
                            }} />
                            }
                            <Divider style={{ marginTop: 5, marginBottom: 10 }} />
                        </Flex>
                    })}
                </Flex>
            </Card>

            <Flex style={{ color: '#1e1d1dff', fontWeight: 600, marginTop: 10 }}>Opções</Flex>
            <Card size='small'>
                <Flex vertical >
                    <Flex align='center' justify='space-between'>
                        <Flex gap={10} align='center'>
                            <PercentageOutlined style={{ color: appref.current?.cor }} />
                            <Flex vertical>
                                <Flex>Cupom Promocional</Flex>
                                {cupom?.idcupons > 0 && <Flex style={{ color: 'gray' }} gap={5}>

                                    {cupom?.tipo === 0 ? <Flex style={{ color: appref.current?.cor, fontWeight: 500 }}>
                                        <Flex gap={5}>  {cupom?.nome}  R${cupom?.valor} OFF</Flex>
                                    </Flex>
                                        :
                                        <Flex gap={5} style={{ color: appref.current?.cor, fontWeight: 500 }}> {cupom?.nome} {cupom?.valor} % OFF</Flex>
                                    }</Flex>
                                }
                            </Flex>
                        </Flex>
                        {allowEdit && <Button type='text' iconPosition='end' icon={<RightOutlined />}
                            onClick={() => {
                                setOpenCupom(true)
                            }}>Adicionar</Button>
                        }
                    </Flex>
                    <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                    <Flex align='center' justify='space-between'>
                        <Flex gap={10} align='center'>
                            <GiftOutlined style={{ color: appref.current?.cor }} />
                            <Flex vertical>
                                <Flex>Programa de Fideliade</Flex>
                                {resgate?.valor > 0 &&
                                    <Flex gap={5} style={{ color: appref.current?.cor, fontWeight: 500 }}> {fidelidade?.nome} {"R$".concat(resgate?.valor.toFixed(2))} OFF</Flex>
                                }
                            </Flex>
                        </Flex>
                        {allowEdit && <Button type='text' iconPosition='end' icon={<RightOutlined />} onClick={() => {
                            loadFidelidade()
                            setOpenFidelidade(true)
                        }}>Adicionar</Button>
                        }
                    </Flex>

                    <Divider style={{ marginBottom: 5, marginTop: 5 }} />

                    <Flex align='center' justify='space-between'>
                        <Flex gap={10} align='center'>
                            <NotificationOutlined style={{ color: appref.current?.cor }} />
                            <Flex vertical>
                                <Flex>Campanhas</Flex>
                                {campanha && <Flex style={{ color: 'gray' }} gap={5}>
                                    {
                                        "1 x ".concat(campanha.produtonome, " - (", campanha.categorianome, ")")
                                    }</Flex>
                                }
                            </Flex>
                        </Flex>
                        {allowEdit && <Button type='text' iconPosition='end' icon={<RightOutlined />}
                            onClick={async () => {
                                setOpenCampanha(true)
                                try {
                                    if (user) {
                                        const resp = await getCampanhasResgateItens(user?.token)
                                        setCampanhaitens(resp)
                                    }
                                } catch (error) {
                                    addToast(error.message, { appearance: 'error', autoDismiss: true })
                                }
                            }}>Resgatar</Button>
                        }
                    </Flex>
                </Flex>
            </Card>

            {renderValores()}

            {
                calcularTotal() < 0 && <Alert banner message=" O valor do pedido não pode ser negativo." type="warning" showIcon />
            }

        </Flex>
    }

    function renderEndereco() {
        return <Flex style={{ padding: 10, width: '100%' }}>
            <TabsR defaultActiveKey="1" appearance="subtle" style={{ marginTop: 10, width: '100%' }}
                activeKey={deliveryType}
                onSelect={(e) => {
                    setDeliveryType(e)
                }}>
                <TabsR.Tab eventKey="1" title={<Flex align='center' gap={3}>
                    <img height={14} src={ENTREGA} />
                    <Flex>Entrega</Flex>
                </Flex>}>
                    <Card size='small'>
                        {taxa < 0 && <Alert banner message="Endereço não atendido nessa unidade."
                            description={<Flex vertical style={{ fontSize: '0.95em', color: 'gray' }}>
                                Seu endereço não está disponível para essa unidade. Por favor, altere seu endereço.
                            </Flex>}
                            type="warning" showIcon />}
                        <EnderecosCtrl setOpenEnderecos={{}} showHeader={false} app={appref.current} />
                    </Card>
                </TabsR.Tab>
                <TabsR.Tab eventKey="2" title={<Flex align='center' gap={3}>
                    <img height={14} src={TAKEAWAY} />
                    <Flex>Retirada</Flex>
                </Flex>}>
                    {renderNossoEndereco()}
                </TabsR.Tab>

            </TabsR>
        </Flex>
    }

    function setPaymentOnline(formData, selectedPaymentMethod) {
        let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
        pedidos[nome].payment = {
            forma: "Online",
            descricao: selectedPaymentMethod,
            valor: (parseFloat(sumItens()) + (taxa > 0 ? taxa : 0)),
            outros: selectedPaymentMethod,
            troco: 0,
            formData: formData
        }
        console.log(pedidos[nome])
        setPedidoDelivery(pedidos)
    }

    function renderPagamento() {
        return <Flex style={{ padding: 10, marginTop: 10 }} vertical>
            <Flex style={{ color: '#1e1d1dff', fontWeight: 600 }} justify='center'>Escolha a Forma de Pagamento</Flex>
            <Flex vertical gap={10} style={{ marginTop: 15 }}>
                {appref.current?.pkmp && <Card
                    size='small'
                    bordered>
                    <Flex justify='space-between'>
                        <Flex vertical align='center'>
                            <Flex gap={10} align='center'>
                                <CreditCardOutlined style={{ color: appref.current.cor }} />
                                Online
                            </Flex>
                            {pedidoDelivery[nome]?.payment?.forma === "Online" && <Flex style={{ color: '#6a6969ff' }}>
                                {pedidoDelivery[nome]?.payment?.formData?.payment_method_id}</Flex>}
                        </Flex>
                        <Flex gap={10} align='center' onClick={() => {
                            setOpenPaymentOnline(true)

                        }}>
                            {pedidoDelivery[nome]?.payment?.forma === "Online" ? <CheckCircleFilled style={{ color: appref.current.cor, fontSize: 18 }} />
                                : <Flex align='center' gap={5}>
                                    selecionar
                                    <RightOutlined />
                                </Flex>}
                        </Flex>
                    </Flex>
                </Card>
                }

                {appref.current?.pix === true && <Card size='small' bordered>
                    <Flex justify='space-between'>
                        <Flex gap={10} align='center'>
                            <Avatar size={16} src={PIX} />
                            PIX
                        </Flex>
                        <Flex gap={10} align='center' onClick={() => {
                            let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                            pedidos[nome].payment = {
                                forma: "Pagamento por pix",
                                descricao: "PIX",
                                valor: (parseFloat(sumItens()) + (taxa > 0 ? taxa : 0)),
                                outros: '',
                                troco: 0
                            }
                            console.log(pedidos[nome])
                            setPedidoDelivery(pedidos)
                        }}>
                            {pedidoDelivery[nome]?.payment?.descricao === "PIX" ? <CheckCircleFilled style={{ color: appref.current.cor, fontSize: 18 }} />
                                : <Flex align='center' gap={5}>
                                    selecionar
                                    <RightOutlined />
                                </Flex>}
                        </Flex>
                    </Flex>
                </Card>
                }

                <Card size='small' bordered>
                    <Flex justify='space-between'>
                        <Flex gap={10} align='center'>
                            {
                                pedidoDelivery[nome]?.payment?.url ?
                                    <img height={20} alt='form' src={pedidoDelivery[nome]?.payment?.url} />
                                    : <Avatar size={16} src={POS} />
                            }

                            <Flex vertical>
                                <Flex>Pagamento na entrega</Flex>
                                {pedidoDelivery[nome]?.payment?.descricao === "Pagamento na entrega" && <Flex style={{ color: '#6a6969ff' }}>{pedidoDelivery[nome]?.payment?.outros}</Flex>}
                            </Flex>
                        </Flex>
                        <Flex gap={10} align='center' onClick={() => {
                            setOpenPaymentEntrega(true)
                        }}>
                            {pedidoDelivery[nome]?.payment?.descricao === "Pagamento na entrega" ? <CheckCircleFilled style={{ color: appref.current.cor, fontSize: 18 }} />
                                : <Flex align='center' gap={5}>
                                    selecionar
                                    <RightOutlined />
                                </Flex>}
                        </Flex>
                    </Flex>
                </Card>

            </Flex>
        </Flex>
    }

    function renderEnderecoEntrega() {
        try {
            let endlst = enderecos.filter(v => v.isprincipal === 1)
            let end = endlst[0]
            //   console.log(end)
            return <Flex style={{ padding: 10 }}>
                <Flex style={{ padding: 10, backgroundColor: 'white', borderRadius: 8 }} vertical flex={1}>
                    <Flex vertical wrap>
                        <Flex align='center' gap={10}>
                            <Flex>
                                {<Avatar size={'small'} src={PLACEHOLDER} />}
                            </Flex>
                            <Flex flex={1} vertical>
                                <Flex style={{ fontWeight: 500 }}> {end?.streetName} {end?.streetNumber} {end?.complement}</Flex>
                                <Flex>{end?.district}, {end?.city}</Flex>
                                <Flex>{end?.postalCode} - {end?.state}</Flex>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>

            </Flex>
        } catch (error) {

        }
    }

    function renderFinalizar() {
        //  console.log(pedidoDelivery[nome])
        return <Flex style={{ padding: 10, marginTop: 10 }} vertical flex={1}>
            <Flex style={{ fontWeight: 600, color: '#1f1f1fff' }}>Resumo do pedido</Flex>
            <Flex style={{ color: 'gray' }}>Confira se os detalhes estão corretos</Flex>
            <Flex style={{ marginTop: 10 }}>{parseInt(deliveryType) === 1 ? <Flex vertical flex={1}>
                <Flex align='center' gap={3} flex={1}>
                    <img height={14} src={ENTREGA} alt='entrega'/>
                    <Flex>Entrega</Flex>
                </Flex>
                {renderEnderecoEntrega()}
            </Flex>
                :
                <Flex vertical flex={1}>
                    <Flex align='center' gap={3}>
                        <img height={14} src={TAKEAWAY} alt='takeaway'/>
                        <Flex>Retirada</Flex>

                    </Flex>
                    {renderNossoEndereco()}

                </Flex>}
            </Flex>

            {renderPedido()}

            <Flex style={{ padding: 10 }} vertical>
                <Flex style={{ fontWeight: 600, color: '#1f1f1fff', marginTop: 5 }}>Forma de Pagamento</Flex>
                <Card size='small'>
                    {pedidoDelivery[nome].payment.forma === "Pagamento por pix" && <Flex justify='space-between' align='center' gap={10}>
                        <Flex>
                            <img height={20} alt='pixlogo' src={PIX_LOGO} />
                        </Flex>
                        <Flex justify='space-between' gap={10} align='center'>
                            <Flex flex={1} vertical>
                                <Flex style={{ fontWeight: 600 }}>Pagamento por pix</Flex>
                                <Flex style={{ color: 'gray' }}>Código será gerado após confirmação.</Flex>
                            </Flex>
                            <Flex align='center' gap={5} onClick={() => setCurrentStep(2)}>
                                <Flex style={{ color: appref.current?.cor }}>trocar</Flex>
                                <RightOutlined />
                            </Flex>
                        </Flex>
                    </Flex>}

                    {pedidoDelivery[nome].payment.forma === "Pagamento na entrega" && <Flex align='center' gap={10}>
                        <Flex>
                            <img height={20} alt='form' src={pedidoDelivery[nome]?.payment?.url} />
                        </Flex>
                        <Flex justify='space-between' gap={10} align='center' flex={1}>
                            <Flex flex={1} vertical>
                                <Flex style={{ fontWeight: 600 }}>Pagamento na entrega</Flex>
                                <Flex style={{ color: 'gray' }}>{pedidoDelivery[nome].payment.outros}</Flex>
                            </Flex>
                            <Flex align='center' gap={5} onClick={() => setCurrentStep(2)}>
                                <Flex style={{ color: appref.current?.cor }}>trocar</Flex>
                                <RightOutlined />
                            </Flex>
                        </Flex>
                    </Flex>}

                    {pedidoDelivery[nome].payment.forma === "Online" && <Flex align='center' gap={10}>
                        <Flex>
                            <CreditCardOutlined style={{ color: appref.current.cor }} />
                        </Flex>
                        <Flex justify='space-between' gap={10} align='center' flex={1}>
                            <Flex flex={1} vertical>
                                <Flex style={{ fontWeight: 600 }}>Online</Flex>
                                <Flex style={{ color: 'gray' }}> {pedidoDelivery[nome]?.payment?.formData?.payment_method_id}</Flex>
                            </Flex>
                            <Flex align='center' gap={5} onClick={() => setCurrentStep(2)}>
                                <Flex style={{ color: appref.current?.cor }}>trocar</Flex>
                                <RightOutlined />
                            </Flex>
                        </Flex>
                    </Flex>}


                </Card>
            </Flex>

        </Flex>
    }

    function renderEnviado() {
        //  console.log(pedidoDelivery[nome])
        return <Flex style={{ padding: 5, marginTop: 5 }} vertical flex={1}>

            <Result
                style={{ backgroundColor: 'white' }}
                status="success"
                title="Pedido enviado com sucesso!"
                subTitle={<Flex vertical gap={5}>
                    <Flex justify='center'>
                        {"Número do pedido: ".concat(respPedido?.id, ", para acompanhar o status do seu pedido clique em Acompanhar Pedido.")}
                    </Flex>
                    {respPedido?.payment?.id && respPedido?.payment?.forma !== 'PIX' &&
                        <Flex vertical>
                            <PaymentStatusCtrl id={respPedido.payment.id} />
                        </Flex>
                    }

                    {respPedido?.payment?.id && respPedido?.payment?.forma === 'PIX' &&
                        <Flex vertical>
                            <Flex justify='center' gap={5} vertical align='center'>

                                <Flex style={{ fontSize: '1.2em', fontWeight: 'bold' }} align='center'>Pague pelo QRCode</Flex>
                                <Flex justify='center'> Pague até às {dayjs(respPedido?.pedido?.createAt).add(10, 'minutes').format('HH:mm:ss')} hs</Flex>
                                <img src={respPedido?.payment.img} height={200} width={200} alt='qrcode'></img>
                                <Input.TextArea value={respPedido?.payment.qrcode} autoSize style={{ width: '100%' }} />
                                <Flex align='center' gap={10} justify='center'>
                                    <Button onClick={() => {
                                        navigator.clipboard.writeText(respPedido?.payment.qrcode)
                                            .then(() => {
                                                addToast('QRCode copiado!', {
                                                    autoDismiss: true, appearance: 'info',
                                                })
                                            })
                                            .catch(err => {
                                                console.error("Erro ao copiar: ", err);
                                            });
                                    }}>Clique para Copiar</Button>


                                    <Button icon={<WhatsAppOutlined style={{ color: 'green' }} />} onClick={() => {
                                        console.log(appref.current)
                                        const fone = appref.current.whatshap.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "")
                                        window.open('https://wa.me/55'.concat(fone, '?text=Segue comprovante do meu Pedido *', respPedido?.id, '*'), '_blank');
                                    }}>Enviar comprovante</Button>

                                </Flex>

                            </Flex>
                        </Flex>
                    }

                </Flex>}
                extra={[
                    <Button type="primary" key="console"
                        onClick={() => {
                            setOpenPedido(true)
                        }}>
                        Acompanhar pedido
                    </Button>,
                    <Button key="buy" onClick={() => {
                        // setOpenCart(false)
                        setOpenEnviado(false)
                    }}>Sair</Button>
                ]}
            />
        </Flex>
    }

    function renderNossoEndereco() {
        return <Card size='small' style={{ width: '100%' }}>
            <Flex align='center' gap={15}>
                <Avatar src={PLACEHOLDER} size={'small'} />
                <Flex vertical>
                    <Flex style={{ fontWeight: 600 }}>Nosso endereço</Flex>
                    <Flex style={{ color: '#3f3e3eff' }} vertical wrap>
                        <Flex>{appref.current.endereco} {appref.current.numero} {appref.current.complemento} - {appref.current.bairro}</Flex>
                        <Flex> {appref.current.cidade} - {appref.current.uf}, {appref.current.cep} / Brasil</Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    }

    function renderStep() {
        switch (currentStep) {
            case 0: return renderPedido(true);
            case 1: return renderEndereco();
            case 2: return renderPagamento();
            case 3: return renderFinalizar();
            default: return renderPedido(true);

            //   case 4: return renderEnviado(); break;
        }
    }


    return <Layout style={{ height: '100vh' }} key={'layout'.concat(force)}>

        {
            location?.pathname === "/".concat(nome, 'app') && <Layout.Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'white',
                    paddingLeft: 10,
                    paddingRight: 10
                }}
            >
                <Flex justify='space-between' style={{ width: '100%' }}>
                    <Flex align='center' gap={10}>
                        {appref.current?.logo ? <Avatar size={'large'} src={BASEURLRAIZ.concat("/logos/", appref.current.logo)} /> : <Avatar size={'large'} src={LOGO} />}
                        {user ? <Flex> <span>Olá, {user?.name.split(' ')[0]} </span> </Flex> :
                            <Flex> </Flex>}

                    </Flex>
                    <Flex gap={3} align='center'>
                        <Button size='small' type='text' icon={<NotificationOutlined style={{ fontSize: '1.2em' }} />} />
                        <Button size='small' type='text' icon={<ShoppingOutlined style={{ fontSize: '1.2em' }} />} />
                    </Flex>
                </Flex>
            </Layout.Header>
        }
        <Layout.Content style={{ padding: 0, overflowY: 'auto' }} id="lcbody" >
            <Outlet context={[appref.current, openCadastro, setOpenCadastro]} key={"status-".concat(force)} />
        </Layout.Content>
        <Layout.Footer style={{
            textAlign: 'center', paddingLeft: 0, paddingRight: 0,
            position: 'absolute', bottom: 0, width: '100%'
        }} id='footerDelivery'>

            {(nome && pedidoDelivery[nome]?.itens?.length > 0 && location?.pathname === "/".concat(nome)) && <Flex align='center'
                style={{
                    paddingBottom: 10,
                    paddingTop: 15,
                    paddingLeft: 10,
                    paddingRight: 10,
                    backgroundColor: appref.current?.cor, color: 'white', width: '100%'
                }}>
                <Flex justify='space-between' style={{ width: '100%' }}
                    onClick={() => {
                        if (appref.current.status?.open === true)
                            setOpenCart(true)
                        else
                            addToast("O estabelecimento está fechado, não é possível efetuar o pedido!", { appearance: 'info', autoDismiss: true })
                    }
                    }>
                    <Flex justify='center' flex={1}>
                        <Badge size='small' count={pedidoDelivery[nome].itens.length}>
                            <img height={20} src={SHOP_BAG} alt='shopbag' />
                        </Badge>
                    </Flex>
                    <Flex justify='center' flex={1}>Meu pedido</Flex>
                    <Flex justify='center' flex={1} align='baseline' gap={2}><span>
                        <span style={{ fontSize: '0.8em' }}>R$</span> <span style={{ fontSize: '1.1em' }}>
                            {sumItens()} </span></span></Flex>
                </Flex>
            </Flex>
            }

            <BottomNavigation
                value={tabSelected}
                onChange={(event, newValue) => {
                    setTabSelected(newValue)
                }}>
                <BottomNavigationAction
                    showLabel={true}
                    icon={<HomeOutlinedIcon style={{ color: tabSelected === 0 ? appref.current.cor : 'gray' }} />}
                    onClick={() => navigate("/".concat(nome))}
                    label={"Home"} />
                <BottomNavigationAction
                    showLabel={true}
                    icon={<ShoppingBagOutlinedIcon
                        style={{ color: tabSelected === 1 ? appref.current.cor : 'gray' }} />}
                    onClick={() => navigate('/'.concat(nome, "/pedidos"))}
                    label={"Pedidos"} />
                <BottomNavigationAction
                    onClick={() => navigate('/'.concat(nome, "/perfil"))}
                    showLabel={true}
                    icon={<PermContactCalendarOutlinedIcon style={{ color: tabSelected === 2 ? appref.current.cor : 'gray' }} />}
                    label={"Perfil"} />
            </BottomNavigation>




        </Layout.Footer>



        <Drawer
            width={'100%'}
            title={null}
            open={openEnviado}
            closable={false}
            footer={null}>
            {renderEnviado()}
        </Drawer>


        {/*  CARRINHO DE PEDIDOS */}
        {nome && pedidoDelivery[nome] && pedidoDelivery[nome].itens?.length > 0 && <Drawer
            destroyOnClose={true}
            afterOpenChange={() => {
                try {
                    setCurrentStep(0)
                    let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                    pedidos[nome].payment = {}
                    setDeliveryType('1')
                    setPedidoDelivery(pedidos)
                    setCupom({ codigo: '' })
                } catch (error) {

                }
            }}
            style={{ backgroundColor: 'whitesmoke' }}
            open={openCart}
            title={<Flex justify='center' align='center' >SEU CARRINHO</Flex>}
            closeIcon={<LeftCircleOutlined style={{ fontSize: '1.3em' }} />}
            placement='left'
            onClose={() => {
                setCurrentStep(0)
                setOpenCart(false)
            }}
            width={'100%'}
            footer={<Flex style={{ width: "100%" }} gap={5} align='center' justify='space-between'>
                {currentStep < 3 ? <Flex justify='center' align='center' vertical style={{ color: '#413f3fff' }}>
                    <Flex><span>{deliveryType === '1' ? "Total com entrega" : "Total para retirada"}</span></Flex>
                    <Flex><span>R$ {(parseFloat(sumItens()) + (taxa < 0 ? 0 : taxa)).toFixed(2)} <Divider type='vertical' style={{ margin: 3, backgroundColor: '#212121ff' }} />
                        {pedidoDelivery[nome].itens.length} {pedidoDelivery[nome].itens.length === 1 ? " item" : " itens"}</span>
                    </Flex>
                </Flex>
                    :
                    currentStep === 4 ? <Flex> </Flex> :
                        <Button icon={<LeftOutlined />}
                            onClick={() => {
                                if (currentStep > 0) {
                                    setCurrentStep(currentStep - 1)
                                    if (currentStep > 1) {
                                        let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                                        pedidos[nome].payment = {}
                                        setPedidoDelivery(pedidos)
                                    }
                                } else {
                                    setOpenCart(false)
                                }
                            }}>Voltar</Button>
                }

                <Flex align='center' gap={6} >
                    {currentStep < 3 && <Button
                        icon={<LeftOutlined />}
                        onClick={() => {
                            if (currentStep > 0) {
                                setCurrentStep(currentStep - 1)
                                if (currentStep > 1) {
                                    let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                                    pedidos[nome].payment = {}
                                    setPedidoDelivery(pedidos)
                                }
                            } else {
                                setOpenCart(false)
                            }
                        }}>Voltar</Button>
                    }

                    {currentStep < 3 && <Button
                        disabled={(parseInt(deliveryType) === 1 && taxa < 0 && currentStep === 1) ||
                            (parseInt(deliveryType) === 2 && currentStep === 2 && !pedidoDelivery[nome].payment?.descricao)
                            ||
                            calcularTotal() < 0
                            ||
                            (currentStep === 2 && !(pedidoDelivery[nome]?.payment?.descricao?.length > 0))
                            ||
                            (!(user?.customer_id > 0) && userNoRegister.name === '' && !validaCelular(userNoRegister.phone))
                        }
                        iconPosition='end'
                        icon={<RightCircleOutlined />}
                        type='primary'
                        style={{ backgroundColor: appref.current?.cor }}
                        onClick={() => {
                            switch (currentStep) {
                                case 0: setCurrentStep(1); break;
                                case 1:
                                    if (parseInt(deliveryType) === 1 && taxa < 0) { }
                                    else
                                        setCurrentStep(2);
                                    break;
                                case 2:

                                    break;
                                default: break;
                            }


                            if (currentStep < 3) {
                                setCurrentStep(currentStep + 1)
                            }
                        }}>
                        Continuar
                    </Button>
                    }
                    {currentStep === 3 && calcularTotal() > 0 && <Flex flex={1}>
                        <Button

                            loading={sending}
                            type='primary'
                            block
                            style={{ backgroundColor: appref.current?.cor }}
                            onClick={async () => {
                                try {
                                    if (sumItens() < appref.current.minimo) {
                                        addToast("O pedido minimo da loja é de R$".concat(appref.current.minimo, ' sem taxas!'), { appearance: 'warning', autoDismiss: true })
                                        return
                                    }
                                    // console.log(user)
                                    // return
                                    setSending(true)
                                    let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                                    pedidos[nome].path = nome
                                    if (cupom.valor > 0)
                                        pedidos[nome].cupom = cupom
                                    pedidos[nome].fidelidade = resgate
                                    pedidos[nome].deliveryType = deliveryType
                                    if (user?.customer_id > 0)
                                        pedidos[nome].usuario = user
                                    else
                                        pedidos[nome].usuario = userNoRegister
                                    pedidos[nome].taxa = taxa
                                    pedidos[nome].total = calcularTotal()
                                    pedidos[nome].produtos = parseFloat(sumItens())
                                    pedidos[nome].orderTiming = "IMMEDIATE"
                                    if (parseInt(deliveryType) === 1) {
                                        pedidos[nome].orderType = "DELIVERY"
                                        let enderecoPrinciapl = enderecos.filter(v => v.isprincipal === 1)
                                        if (enderecoPrinciapl && enderecoPrinciapl.length > 0) {
                                            pedidos[nome].delivery = enderecoPrinciapl[0]
                                        }
                                    } else {
                                        pedidos[nome].orderType = "TAKEOUT"
                                        if (pedidos[nome].orderTiming === "IMMEDIATE") {
                                            switch (appref.current.entrega) {
                                                case "15-30min":
                                                    pedidos[nome].entregaprevistainicio = dayjs().add(30, 'minutes').format('YYYY-MM-DD HH:mm:ss'); break;
                                                case "30-45min":
                                                    pedidos[nome].entregaprevistainicio = dayjs().add(45, 'minutes').format('YYYY-MM-DD HH:mm:ss'); break;
                                                case "45-60min":
                                                    pedidos[nome].entregaprevistainicio = dayjs().add(60, 'minutes').format('YYYY-MM-DD HH:mm:ss'); break;
                                                case "60-1h30min":
                                                    pedidos[nome].entregaprevistainicio = dayjs().add(90, 'minutes').format('YYYY-MM-DD HH:mm:ss'); break;
                                                default:
                                                    pedidos[nome].entregaprevistainicio = dayjs().add(45, 'minutes').format('YYYY-MM-DD HH:mm:ss'); break;
                                            }
                                        }
                                    }
                                    //  console.log(pedidos[nome])
                                    const resp = await postPedido(user?.token, pedidos[nome])
                                    pedidos[nome].idsales = resp.id
                                    pedidos[nome].path = nome
                                    setRespPedido(resp)
                                    console.log(resp)
                                    setCurrentStep(0)
                                    //  setCurrentStep(0)
                                    pedidos[nome] = {}
                                    setPedidoDelivery(pedidos)

                                    let aux = JSON.parse(JSON.stringify(pedidosUltimos))
                                    console.log(aux)
                                    aux.unshift(resp.pedido)
                                    setPedidosUltimos(aux)
                                    setOpenEnviado(true)

                                } catch (error) {
                                    addToast(error.message, { appearance: 'error', autoDismiss: true })
                                }
                                setSending(false)

                            }}>Enviar pedido</Button>
                    </Flex>}

                    {
                        currentStep === 4 && <Button
                            type='primary'
                            style={{ backgroundColor: appref.current?.cor }}
                            onClick={() => {
                                setOpenPedido(false)
                                setOpenCart(false)
                            }}>
                            Fechar
                        </Button>
                    }

                </Flex>

            </Flex>}>
            <Flex vertical flex={1} style={{ marginTop: 8 }}>
                <Stepper activeStep={currentStep} alternativeLabel style={{ fontSize: '0.9em', color: appref.current.cor }}>
                    <Step >
                        <StepLabel>Pedido</StepLabel>
                    </Step>
                    <Step >
                        <StepLabel>Endereço</StepLabel>
                    </Step>
                    <Step>
                        <StepLabel>Pagamento</StepLabel>
                    </Step>
                    <Step >
                        <StepLabel>Finalizar</StepLabel>
                    </Step>
                </Stepper>

                {renderStep()}
            </Flex>
        </Drawer>
        }


        { //formas de pagamento
            <Drawer
                zIndex={99999999919}
                open={openPaymentEntrega}
                title={<Flex justify='center'>Escolha uma das opções</Flex>}
                onClose={() => setOpenPaymentEntrega(false)}
                footer={null}>
                <List
                    size='small'
                    dataSource={appref.current?.pagamentos_offline}
                    renderItem={(item) => {
                        return <List.Item
                            actions={[<RightOutlined />]}
                            onClick={() => {
                                console.log(item)
                                if (item.name.toUpperCase() === "DINHEIRO") {
                                    setOpenPaymentEntrega(false)
                                    setOpenTroco(true)

                                    let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                                    pedidos[nome].payment = {
                                        url: item.url,
                                        forma: "Pagamento na entrega",
                                        descricao: "Pagamento na entrega",
                                        valor: parseFloat(sumItens()) + (taxa > 0 ? taxa : 0),
                                        outros: item.name,
                                        troco: 0,
                                        paymentMethods_id: item.paymentMethods_id,
                                        prepago: false
                                    }
                                    setPedidoDelivery(pedidos)

                                } else {
                                    let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                                    pedidos[nome].payment = {
                                        url: item.url,
                                        forma: "Pagamento na entrega",
                                        descricao: "Pagamento na entrega",
                                        valor: parseFloat(sumItens()) + (taxa > 0 ? taxa : 0),
                                        outros: item.name,
                                        troco: 0,
                                        paymentMethods_id: item.paymentMethods_id,
                                        prepago: false
                                    }
                                    setPedidoDelivery(pedidos)
                                    setOpenPaymentEntrega(false)
                                }

                            }}>
                            <List.Item.Meta
                                avatar={<img width={18} height={12} src={item.url} alt='userna'/>}
                                title={item.name}
                            />
                        </List.Item>
                    }}>

                </List>

            </Drawer>
        }


        { //troco
            <Drawer
                placement='bottom'
                height={300}
                open={openTroco}
                title={null}
                closable={false}
                onClose={() => { }}>
                <Flex justify='center' gap={5} vertical align='center'>
                    <Flex style={{ color: '#1e1d1dff', marginTop: 15, fontSize: '1.1em', fontWeight: 600 }}>Troco para quanto?</Flex>
                    <Flex style={{ color: '#606060ff' }}>Seu pedido deu R$ {(parseFloat(sumItens()) + (taxa > 0 ? taxa : 0)).toFixed(2)}</Flex>

                    <Flex vertical justify='flex-start' style={{ marginTop: 15 }} gap={0}>
                        <Flex>Digite o valor</Flex>
                        <InputNumber
                            precision={2}
                            addonBefore={"R$"}
                            defaultValue={(parseFloat(sumItens()) + (taxa > 0 ? taxa : 0)).toFixed(2)}
                            style={{
                                width: 150, textAlign: 'right', justifyContent: 'end',
                                justifyItems: 'end', justifySelf: 'end', alignContent: 'end'
                            }}
                            value={troco}
                            onChange={(e) => setTroco(e)} onBlur={() => {
                                try {
                                    if (parseFloat(troco) < (parseFloat(sumItens()) + (taxa > 0 ? taxa : 0))) {
                                        setTroco((parseFloat(sumItens()) + (taxa > 0 ? taxa : 0)))
                                    }
                                } catch (error) {

                                }
                            }} />
                    </Flex>


                    <Flex justify='center' style={{ marginTop: 15, width: '50%' }} gap={10} vertical align='center'>
                        <Button type='primary' block style={{ backgroundColor: appref.current.cor }}
                            onClick={() => {
                                setOpenTroco(false)

                                let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                                const url = pedidos[nome].payment.url
                                pedidos[nome].payment = {
                                    url: url,
                                    forma: "Pagamento na entrega",
                                    descricao: "Pagamento na entrega",
                                    valor: parseFloat(sumItens()),
                                    outros: parseFloat(troco) > (parseFloat(sumItens()) + (taxa > 0 ? taxa : 0)) ? "".concat("Dinheiro : troco para ", parseFloat(troco).toFixed(2)) : "Dinheiro",
                                    troco: troco
                                }
                                setPedidoDelivery(pedidos)
                                setOpenPaymentEntrega(false)
                            }}>Confirmar</Button>
                        <Button type='primary' block style={{ backgroundColor: appref.current.cor }}
                            onClick={() => {

                                setOpenTroco(false)
                                let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                                const url = pedidos[nome].payment.url
                                pedidos[nome].payment = {
                                    url: url,
                                    forma: "Pagamento na entrega",
                                    descricao: "Pagamento na entrega",
                                    valor: parseFloat(sumItens()) + (taxa > 0 ? taxa : 0),
                                    outros: "Dinheiro",
                                    troco: 0
                                }
                                setPedidoDelivery(pedidos)
                                setOpenPaymentEntrega(false)
                            }}>Sem troco</Button>
                    </Flex>

                </Flex>

            </Drawer>
        }


        { // opcaos cancelar ou editar item
            <Drawer
                zIndex={99999999919}
                placement='bottom'
                height={230}
                open={openEdit}
                closeIcon={null}
                title={null}
                onClose={() => setOpenEdit(false)}>

                <Flex vertical justify='center' align='center' gap={10} style={{ padding: 15 }}>
                    <Flex style={{ color: '#1d1c1cff', fontWeight: 600, marginTop: 5 }}>Escolha uma das opções</Flex>

                    <Button style={{ marginTop: 15, backgroundColor: appref.current?.cor }} type='primary' block
                        onClick={() => {
                            setOpenEdit(false)
                            setOpenSelected(true)

                        }}>Editar</Button>
                    <Button style={{ marginTop: 0 }} danger block onClick={() => {
                        try {
                            let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
                            pedidos[nome].itens.splice(selectedIndex, 1)
                            setOpenEdit(false)
                            setPedidoDelivery(pedidos)
                            if (pedidos[nome].itens.length === 0)
                                setOpenCart(false)
                        } catch (error) {

                        }
                    }}>Remover</Button>
                </Flex>

            </Drawer>
        }


        {itemSelected &&
            <Drawer
                width={'100%'}
                id='dwrItem'
                open={openSelected}
                title={null}
                onClose={() => setOpenSelected(false)}
                destroyOnClose={true}
                closable={false}
                footer={
                    <Flex style={{ width: '100%' }} justify='space-between'>
                        <Flex justify='left'>
                            <Flex style={{
                                borderWidth: 0.7, borderColor: 'lightgrey',
                                borderRadius: 5, borderStyle: 'solid', marginRight: 30
                            }} align='center' gap={5}>
                                <Button

                                    type='link' icon={<MinusOutlined />}
                                    onClick={() => {
                                        if (!itemSelected?.quant)
                                            itemSelected.quant = 0
                                        itemSelected.quant = itemSelected?.quant - 1
                                        if (itemSelected.quant <= 0)
                                            itemSelected.quant = 1
                                        setItemSelected({ ...itemSelected })
                                    }} />
                                <Flex style={{ width: 30, fontSize: '1.2em', fontWeight: 'bold', color: appref.current?.cor }} justify='center'> {itemSelected?.quant}</Flex>
                                <Button

                                    type='link' icon={<PlusOutlined />}
                                    onClick={() => {
                                        if (!itemSelected?.quant)
                                            itemSelected.quant = 0
                                        itemSelected.quant = itemSelected?.quant + 1
                                        setItemSelected({ ...itemSelected })
                                    }} />
                            </Flex>
                        </Flex>
                        <Flex flex={1} >
                            <Button
                                style={{ backgroundColor: appref.current?.cor }}
                                type='primary'
                                block
                                disabled={!selectedValided}
                                onClick={() => {
                                    addItem(itemSelected)
                                    setItemSelected(undefined)
                                    setOpenSelected(false)
                                }}>
                                <Flex align='center' gap={8}>
                                    <Flex style={{ fontWeight: 'bold' }}>ATUALIZAR</Flex>
                                    <Flex>R$ {sumItem()}</Flex>
                                </Flex>
                            </Button>
                        </Flex>
                    </Flex>
                }>
                <Flex vertical gap={5}>
                    {
                        itemSelected?.url && <Image
                            placeholder={<Placeholder.Graph active />}
                            src={itemSelected.url} width={'100%'} />
                    }

                    <div style={{ position: 'absolute', marginLeft: 20, marginTop: itemSelected?.url ? 20 : 40 }}>
                        <Avatar style={{ backgroundColor: 'gray' }} icon={<LeftOutlined style={{ color: 'white' }} />}
                            onClick={() => setOpenSelected(false)} />
                    </div>
                    <Flex style={{ paddingLeft: 10, paddingTop: 10, paddingRight: 10 }} vertical>
                        <Flex style={{ fontWeight: 600, color: '#373737ff', fontSize: '1.3em', marginTop: 9 }}>{itemSelected.name}</Flex>
                        <Flex wrap style={{ color: 'gray' }}>{itemSelected?.note}</Flex>
                        {itemSelected.value > 0 &&
                            renderPreco(itemSelected)}

                    </Flex>

                    <Flex style={{ width: '100%', marginTop: 10 }} vertical>
                        {
                            itemSelected?.groups?.map((gp, indexgp) => {
                                return <Flex vertical key={"gp".concat(indexgp)} style={{ width: '100%' }}>
                                    <Flex style={{
                                        fontSize: '1em', fontWeight: 600, marginLeft: 5, backgroundColor: 'whitesmoke',
                                        padding: 8, paddingLeft: 15, marginBottom: 10
                                    }}
                                        gap={10} align='center'>
                                        <Flex justify='space-between' align='center' style={{ width: '100%' }}>
                                            <Flex align='center'>
                                                <Flex vertical>
                                                    <Flex>{gp.name} </Flex>
                                                    <Flex style={{ fontSize: '0.75em', color: "#757575ff" }}> {gp.minimum <= gp.maximum ? "Escolha " : "Escolha até "} {gp.maximum} {gp.maximum === 1 ? "opção" : "opções"}</Flex>
                                                </Flex>
                                                <Tag style={{ marginLeft: 15, fontSize: '0.8em' }} color={gp.minimum > 0 ? appref.current?.cor : 'default'} > {gp.mandatory > 0 ? 'obrigatório' : 'opcional'}</Tag>
                                            </Flex>
                                            <Flex vertical style={{ marginRight: 20, color: 'royalblue' }}>
                                                {(gp.mandatory > 0 && gp.valided) && <CheckOutlined />}
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                    <Flex gap={2} style={{ width: '100%' }} vertical>
                                        {
                                            gp.items?.map((gpi, indexgpi) => {
                                                return <Flex vertical>
                                                    <Flex justify='space-between' key={'gpi'.concat(gpi.groupsitems_id)}
                                                        style={{ paddingLeft: 30, cursor: 'pointer' }}
                                                        onClick={() => {
                                                            let indexTemp = -1
                                                            if (gp.maximum === 1) {
                                                                gp.items?.map((gpi, indexgpi) => {
                                                                    if (gpi.sel === 1)
                                                                        indexTemp = indexgpi
                                                                    return gpi.sel = 0
                                                                })
                                                                if (indexTemp !== indexgpi)
                                                                    gpi.sel = 1
                                                                setItemSelected({ ...itemSelected })
                                                            }
                                                            if (gp.mandatory > 0) {
                                                                const somaSel = gp.items.reduce((acumulador, current) => acumulador + (current.sel ? current.sel : 0), 0)
                                                                if (gp.minimum <= somaSel)
                                                                    gp.valided = true
                                                                else
                                                                    gp.valided = false
                                                            }

                                                        }}>
                                                        <Flex style={{ color: "#757575ff" }} gap={15}>
                                                            {gpi.name} {gpi.value > 0 && <span style={{ marginLeft: 5 }}>+ R$
                                                                {parseFloat(gpi?.value).toFixed(2)}
                                                            </span>}
                                                        </Flex>
                                                        <Flex style={{ paddingRight: 15 }}> {
                                                            gp.maximum === 1 ? <Radio checked={gpi.sel === 1 ? true : false}></Radio> :
                                                                <Flex align='center' >
                                                                    <Button type='link' style={{ display: gpi.sel > 0 ? 'block' : 'none' }} icon={<MinusOutlined />}
                                                                        onClick={() => {
                                                                            if (gpi.sel === undefined)
                                                                                gpi.sel = 0
                                                                            gpi.sel = gpi.sel - 1
                                                                            if (gpi.sel < 0)
                                                                                gpi.sel = 0

                                                                            if (gp.mandatory > 0) {
                                                                                const somaSel = gp.items.reduce((acumulador, current) => acumulador + (current.sel ? current.sel : 0), 0)
                                                                                if (gp.minimum <= somaSel)
                                                                                    gp.valided = true
                                                                                else
                                                                                    gp.valided = false
                                                                            }
                                                                            setItemSelected({ ...itemSelected })
                                                                        }}
                                                                    />
                                                                    <Flex style={{ width: 30, display: gpi.sel > 0 ? 'block' : 'none', textAlign: 'center' }} justify='center'>{gpi.sel}</Flex>
                                                                    <Button type='link' icon={<PlusOutlined />}
                                                                        onClick={() => {
                                                                            const somaSel = gp.items.reduce((acumulador, current) => acumulador + (current.sel ? current.sel : 0), 0)
                                                                            if (somaSel >= gp.maximum)
                                                                                return
                                                                            if (gpi.sel === undefined)
                                                                                gpi.sel = 0
                                                                            gpi.sel = gpi.sel + 1
                                                                            if (gpi.sel < 0)
                                                                                gpi.sel = 0
                                                                            setItemSelected({ ...itemSelected })
                                                                        }} />
                                                                </Flex>
                                                        }
                                                        </Flex>

                                                    </Flex>
                                                    <Divider style={{ marginBottom: 5, marginTop: 4 }} />
                                                </Flex>

                                            })
                                        }
                                    </Flex>
                                </Flex>
                            })
                        }
                    </Flex>

                    <Divider style={{ marginTop: 2, marginBottom: 5 }} />
                    <Flex vertical style={{ padding: 12 }}>
                        <Flex justify='space-between' >
                            <Flex align='center' gap={10}>
                                <CommentOutlined />
                                Alguma Observação?
                            </Flex>
                            <Flex align='center' style={{ color: 'gray' }}>
                                0/140
                            </Flex>
                        </Flex>
                        <Input.TextArea

                            maxLength={140}
                            style={{ marginTop: 5, marginBottom: 20 }}
                            value={itemSelected?.obs}
                            onChange={(e) => setItemSelected({ ...itemSelected, obs: e.target.value })} />
                    </Flex>

                </Flex>

            </Drawer>
        }

        {/* CUPOM*/}
        <Drawer
            zIndex={999999999}
            placement='bottom'
            open={openCupom}
            title={null}
            height={250}
            closeIcon={null}
            onClose={() => setOpenCupom(false)}>
            <Flex style={{ padding: 20 }} justify='center' vertical align='center' gap={5}>
                <Flex style={{ fontWeight: 600, fontSize: '1.15em' }}>Código do cupom</Flex>
                <Flex style={{ color: 'gray', textAlign: 'center', paddingLeft: 20, paddingRight: 20, textJustify: 'auto' }} justify='center'>
                    <span>Adicione o código promocional do seu cupom e <span style={{ fontWeight: 600 }}>ganhe seu desconto na hora</span></span>
                </Flex>
                <Flex style={{ marginTop: 20, width: '100%' }} justify='center'>
                    <Input
                        style={{ width: '70%', textAlign: 'center' }}
                        placeholder='Informe o código do seu cupom'
                        value={cupom.codigo}
                        onChange={(e) => setCupom({ ...cupom, codigo: e.target.value })} />
                </Flex>

                <Button
                    disabled={cupom?.codigo?.trim() === ''}
                    style={{ backgroundColor: appref.current?.cor, marginTop: 10, width: '70%' }} type='primary'
                    onClick={async () => {
                        try {
                            setMsgCupom('')
                            const resp = await getLocalizarCupom(user?.token, cupom)
                            //  console.log(resp)
                            if (resp.length === 0)
                                setMsgCupom("Nenhum cupom localizado!")
                            if (resp[0].quantidade > resp[0].utilizados) {
                                if (resp[0].valorminimo <= parseFloat(sumItens())) {
                                    setCupom(resp[0])
                                    setOpenCupom(false)
                                } else
                                    setMsgCupom("O valor minimo para utilizar o cupom é R$".concat(resp[0].valorminimo, "!"))

                            } else
                                setMsgCupom("Quantidade de cupons excedida!")

                        } catch (error) {

                        }
                    }}>ADICIONAR</Button>
                <Flex style={{ color: 'red', fontSize: 11 }} justify='center'>
                    {msgCupom}
                </Flex>

            </Flex>
        </Drawer>



        {/* FIDELIDADE*/}
        <Drawer
            zIndex={999999999}
            placement='bottom'
            open={openFidelidade}
            title={null}
            height={220}
            closable={false}
            closeIcon={null}
            footer={
                <Flex justify='flex-end' gap={15}>
                    <Button onClick={() => {
                        setOpenFidelidade(false)
                    }}>Fechar</Button>

                    {fidelidade?.saldo >= fidelidade.pontos && fidelidade?.situacao === 1 && <Button type='primary'
                        style={{ backgroundColor: appref.current?.cor }}
                        onClick={async () => {
                            setOpenFidelidade(false)
                            setResgate({ valor: fidelidade.resgate })

                            //  console.log(fidelidade)
                        }}>Resgatar</Button>
                    }
                </Flex>
            }
            onClose={() => setOpenFidelidade(false)}>

            <Flex style={{ color: "#242424ff", fontWeight: 600, marginTop: 15 }} justify='center'>Programa de Fidelidade</Flex>
            {fidelidade?.situacao === 1 && <Flex style={{ color: "gray" }} justify='center'>{fidelidade?.nome}</Flex>}

            {fidelidade?.situacao === 1 ?
                <Flex style={{ width: '100%', padding: 15 }} vertical>
                    <Flex align='center' justify='space-between' style={{ width: '100%' }}>
                        <Flex align='center' gap={4}>
                            <img height={14} src={SELO} alt='historico' />
                            Sua pontuação
                        </Flex>
                        <Flex>{fidelidade?.saldo} / {fidelidade.pontos} pts</Flex>
                    </Flex>
                    <Divider style={{ marginTop: 3, marginBottom: 5 }} />

                    {fidelidade?.saldo >= fidelidade.pontos ? <Flex style={{ color: 'gray', textAlign: 'center', marginTop: 5 }}>
                        <span>Você possui um crédito de R$ <span style={{ fontWeight: 600 }}>{fidelidade.resgate}</span> para ser resgatado.</span>
                    </Flex> : <Flex style={{ color: 'gray', textAlign: 'center', marginTop: 5 }}> Você ainda não atingiu a pontuação necessária para o resgate. </Flex>}


                </Flex> : <Flex justify='center' vertical align='center' gap={10} style={{ padding: 15, textAlign: 'center', color: 'gray' }}>
                    <img height={30} width={30} src={TRISTE} alt='triste'/>
                    Que pena, nenhum programa de fidelidade foi encontrado.
                </Flex>
            }
        </Drawer>


        <Drawer
            zIndex={99999999999}
            open={openCampanha}
            placement='bottom'
            height={350}
            title={null}
            closable={false}
            footer={
                <Flex justify='flex-end'><Button onClick={() => {
                    setOpenCampanha(false)
                    setCampanha(undefined)
                }}>Fechar</Button></Flex>
            }>
            <Flex style={{ color: "#242424ff", fontWeight: 600, marginTop: 15 }} justify='center'>Itens para resgate</Flex>

            {
                campanhaItens.length === 0 ? <Flex align='center' justify='center' style={{ marginTop: 10, color: 'gray' }} vertical>
                    <Divider />
                    <Avatar src={TRISTE2} size={'default'} />
                    Você não possui itens disponíveis para resgate!
                </Flex> : <List size='small'

                    dataSource={campanhaItens}
                    renderItem={item => {
                        return <List.Item
                            actions={[<RightOutlined />]}
                            onClick={() => {
                                setCampanha(item)
                                setOpenCampanha(false)
                            }}>
                            <Skeleton avatar title={false} loading={item.loading} active>
                                <List.Item.Meta
                                    avatar={<Avatar shape='square' src={item.url} size={'large'} />}
                                    title={item.produtonome}
                                    description={item.categorianome}
                                />

                            </Skeleton>
                        </List.Item>
                    }} />
            }


        </Drawer>


        {
            openPaymentOnline && <Drawer
                destroyOnClose={true}
                width={isMobile ? '100%' : 550}
                zIndex={99999999919}
                open={openPaymentOnline}
                title={<Flex justify='center'>Pagamento Online</Flex>}
                onClose={() => setOpenPaymentOnline(false)}
                footer={null}>
                {
                    /*
                    <PaymentCtrl amount={calcularTotal()} setOpenPaymentOnline={setOpenPaymentOnline} setPaymentOnline={setPaymentOnline} />
                    */
                }

                <PaymentPagamerCtrl />

            </Drawer>
        }


        {/* Acompanhar pedido */}
        {respPedido && <Drawer
            destroyOnClose={true}
            width={'100%'}
            open={openPedido}
            title={null}
            closable={false}
            footer={null}>
            <Flex vertical gap={5}>
                <Flex gap={10} align='center'>
                    <Button size='small' type='text' icon={<LeftOutlined />} onClick={() => setOpenPedido(false)}></Button>
                    <b>   <span style={{ fontSize: '1.1em' }}>Pedido: <span style={{ color: '#000' }}>{respPedido?.id}</span></span> </b>
                </Flex>
                <CupomCtrl saleid={respPedido.id} app={appref.current} />
            </Flex>
            <Divider style={{ marginTop: 3, marginBottom: 3 }} />
        </Drawer>
        }


    </Layout>

    async function loadFidelidade() {
        try {
            if (user) {
                const resp = await getFidelidade(user?.token)
                console.log(resp)
                setFidelidade(resp)
            }
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
    }

}



export default OutletDelivery